import { translate } from './translationService';

type Lang = 'en' | 'es' | 'ja';

// The banner is a CSS marquee that scrolls one copy of this content from 0 to
// -100% and loops, so the visible strip only needs enough links to span the
// widest viewport once. A handful repeated is plenty — the old 1000x loop
// produced 2000 DOM nodes for no visual benefit.
const BANNER_REPEAT = 12;

export const generateBannerContent = (language: Lang) => {
  const content: JSX.Element[] = [];
  const appleMusicLink = "https://music.apple.com/profile/unisada";
  const arenaReadingLink = "https://www.are.na/unique-sada/channels";

  for (let i = 0; i < BANNER_REPEAT; i++) {
    content.push(
      <a key={i * 2} href={arenaReadingLink} target="_blank" rel="noopener noreferrer">
        {translate('read', language)}
      </a>
    );
    content.push(
      <a key={i * 2 + 1} href={appleMusicLink} target="_blank" rel="noopener noreferrer">
        {translate('listen', language)}
      </a>
    );
  }

  return content;
};
